














import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
class PageReadListRequest extends PageRequest {
  workId: number;
}
@Component({
  components: {},
})
export default class FlowPath extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 0 }) workorderId: number;
  pagerequest: PageReadListRequest = new PageReadListRequest();
  /**工单动作 */
  statelist: any[] = [];
  create() { }
  created() {
  }
  get list() {
    return this.$store.state.workdetail.list;
  }
  cancel() {
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
    this.getpage();
  }
  /**获取工单动作 */
  getActionList(id: number) {
    let str = this.L('Unknown');
    switch (id) {
      case 1:
        str = this.L('AddWorkOrder')
        break;
      case 2:
        str = this.L('EditWorkOrder')
        break;
      case 3:
        str = this.L('Dispatch')
        break;
      case 4:
        str = this.L('Transmit')
        break;
      case 5:
        str = this.L('StartProcess')
        break;
      case 6:
        str = this.L('EndProcess')
        break;
      case 7:
        str = this.L('Rescind')
        break;
    }
    return str;
  }
  data() {
    return {
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
      datepicker: {
        shortcuts: [
          {
            text: this.L("OneWeek"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: this.L("OneMonth"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: this.L("ThreeMonths"),
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
    };
  }
  pageChange(page: number) {
    this.$store.commit("workdetail/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("workdetail/setPageSize", pagesize);
    this.getpage();
  }
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

    await this.$store.dispatch({
      type: "workdetail/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.workdetail.pageSize;
  }
  get totalCount() {
    return this.$store.state.workdetail.totalCount;
  }
  get currentPage() {
    return this.$store.state.workdetail.currentPage;
  }
  get loading() {
    return this.$store.state.workdetail.loading;
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
    },
    {
      title: this.L("ActionUser"),
      key: "operater",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.operater,
            },
          },
          params.row.operater
        );
      },
    },
    {
      title: this.L("HandleTime"),
      key: "operateTime",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.operateTime == null
            ? ""
            : Moment(params.row.operateTime).format("YYYY-MM-DD HH:mm:ss")
        );
      },
    },
    {
      title: this.L("WorkOrderAction"),
      key: "actionId",
      sortable: true,
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.actionId == null
            ? ""
            : this.getActionList(params.row.actionId)
        );
      },
    },
    {
      title: this.L("ProcessInfo"),
      key: "operateResult",
      sortable: true,
      width: 130,
    },
  ];
  @Watch("workorderId")
  getitemId() {
    this.pagerequest.workId = this.workorderId;
  }
}
